<template>
  <div style="padding-top: 15px">
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-sm-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              <div
                class="row table-responsive"
                style="padding-bottom: 60px; margin: 0 !important"
              >
                <el-button type="primary" @click="handleExportHistoryRound(1)">
                  Export Round 1 History
                </el-button>
                <el-button type="primary" @click="handleExportHistoryRound(2)">
                  Export Round 2 History
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  components: {
    draggable,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },
  methods: {
    async handleExportHistoryRound(roundNum) {
      const param= new FormData()
      param.append("userId",this.userInfo.userId)
      param.append("token",this.userInfo.token)
      param.append("round",roundNum)
      const { data } = await axios.post(
        this.baseURL + "stemupJudge/exportHsbcHistory",
        param,
        {
          responseType: "blob",
        }
      );
      if (data.status_code) {
        if (data.status_code == "000104") return this.timeoutEvent();
        this.$store.getters.warning.warningMsg = data.status_message;
        this.$store.getters.warning.warningFalg = true;
      } else {
        const xlsFileName =
          "HSBC_Judge_History_Round "+roundNum+"_"+ this.$dayjs().format("YYYYMMDDHHmm") + ".xls";
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", xlsFileName);
        document.body.appendChild(link);
        link.click();
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>

</style>
